<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-family m-0">
                                    <i class="ri-file-text-line me-1 text-primary"></i>Experiences
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Search experiences by title." placement="top" container="body">
                                        <i class="bx bx-search-alt"></i>
                                    </span>
                                    <input type="text" class="form-control border-start-0" id="search"
                                        placeholder="Search..." autocomplete="off" [(ngModel)]="searchKeyword" />
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertExperience()"
                                    [ngClass]="{'not-allowed': !privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): personnel.experience.edit' : ''">
                                    <i class="bx bx-plus"></i> Add Experience
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Title</th>
                                    <th scope="col" width="200">Company</th>
                                    <th scope="col" width="150">Start Date</th>
                                    <th scope="col" width="150">End Date</th>
                                    <!-- <th scope="col" width="150">Location Type</th>
                                    <th scope="col" width="150">Employment Type</th> -->
                                    <th scope="col" width="200" class="text-center">Document File</th>
                                    <th scope="col" width="200">Status</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let experience of experiences | search : 'title' : searchKeyword; let i = index">
                                    <td>{{ i + 1 }}.</td>
                                    <td>{{ experience.title }}</td>
                                    <td>{{ experience.company }}</td>
                                    <td>{{ experience.startDate | date:'MMM dd, yyyy'}}</td>
                                    <td>{{ experience.endDate | date:'MMM dd, yyyy' || '-' }}</td>
                                    <!-- <td>{{ experience.locationType }}</td>
                                    <td>{{ experience.employmentType  }}</td> -->
                                    <td class="text-center">
                                        <ng-container *ngIf="experience.documentUrl; else defaultAvatar">
                                          <!-- Show appropriate icon based on file type -->
                                          <ng-container *ngIf="isPdfFile(experience.documentUrl); else imageFile">
                                            <!-- PDF icon for PDF files -->
                                            <i class="bx bxs-file-pdf text-danger" style="font-size: 24px; cursor: pointer;"
                                               (click)="upsertpopup(experience)" 
                                               [ngbTooltip]="'View PDF document'"></i>
                                          </ng-container>
                                          <ng-template #imageFile>
                                            <!-- Image preview for image files -->
                                            <img [src]="experience.documentUrl" alt="Document Image" width="30" height="25" 
                                                 (click)="upsertpopup(experience)"    [ngbTooltip]="'View Image'" style="cursor: pointer;" />
                                          </ng-template>
                                        </ng-container>
                                        <ng-template #defaultAvatar>
                                          <img src="assets/images/no_media.png" alt="Default Avatar" width="30" height="25" />
                                        </ng-template>
                                      </td>
                                      <td> <span class="badge rounded-pill bg-{{ experience.verificationStatus === 'VERIFIED' ? 'success' : 'warning' }}">
                                        {{ experience.verificationStatus }}
                                      </span></td>
                                    <td class="actions">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" [id]="i"
                                                [checked]="experience.disabled"
                                                [ngClass]="{'no-event': experience?.isDeleteInProgress, 'not-allowed': !privilege.canEdit}"
                                                [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): personnel.experience.edit' : experience.disabled ? 'Mark ' + experience.title + ' as enabled.' : 'Mark ' + experience.title + ' as disabled.'"
                                                placement="top" container="body" [(ngModel)]="experience.disabled"
                                                (change)="toggleExperienceStatus(experience)" />
                                            <label class="form-check-label" [for]="i"></label>
                                        </div>
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event': experience?.isDeleteInProgress, 'not-allowed': !privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): personnel.experience.edit' : 'Update Experience'"
                                            (click)="upsertExperience(experience)"></i>
                                        <i *ngIf="!experience?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed': !privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): personnel.experience.delete' : 'Delete Experience'"
                                            (click)="deleteExperience(experience, i)"></i>
                                        <div *ngIf="experience?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="8">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="experiences && experiences.length < 1; else noSearchResults">
                                            <td colspan="8">No experiences were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="8"
                                                *ngIf="searchKeyword && (experiences | search : 'title' : searchKeyword).length == 0">
                                                No experiences were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>